"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Span = exports.ListItem = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ListItem = exports.ListItem = /*#__PURE__*/(0, _base.default)("li", process.env.NODE_ENV === "production" ? {
  target: "e1xvofrz2"
} : {
  target: "e1xvofrz2",
  label: "ListItem"
})(process.env.NODE_ENV === "production" ? {
  name: "qr8q5p",
  styles: "list-style:none"
} : {
  name: "qr8q5p",
  styles: "list-style:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("button", process.env.NODE_ENV === "production" ? {
  target: "e1xvofrz1"
} : {
  target: "e1xvofrz1",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("display:flex;min-height:50px;width:100%;border-radius:", props.lightTheme ? '8px 0 0 8px' : '4px 0 0 4px', ";border:none;background-color:transparent;padding-left:1em;padding-right:0;align-items:center;outline:none;cursor:pointer;&.active{background:", props.lightTheme ? props.theme.lightMenuItemActiveBackground : props.theme.defaultMenuItemActiveBackground, ";&>span{font-weight:700;}}&>span{display:flex;align-items:center;width:100%;text-align:left;line-height:24px;font-weight:600;white-space:nowrap;&>svg{margin-right:10px;min-width:14px;}&>span{transition:width 0.2s ease-out;overflow:hidden;width:", props.small ? '0' : '100%', ";}}&:hover,&:focus{text-decoration:underline;background-color:transparent;text-underline-offset:2px;text-decoration-color:", props.lightTheme ? props.theme.lightMenuTextColor : props.theme.defaultMenuTextColor, ";&.active{background:", props.lightTheme ? props.theme.lightMenuItemActiveBackground : props.theme.defaultMenuItemActiveBackground, ";}}@media screen and (max-width: ", _breakpoints.default.medium, "){padding:0 40px;border-radius:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));
const Span = exports.Span = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e1xvofrz0"
} : {
  target: "e1xvofrz0",
  label: "Span"
})(props => /*#__PURE__*/(0, _react.css)("&>span{transition:width 0.2s ease-out;overflow:hidden;width:", props.small ? '0' : '100%', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:Span;")));